export default __webpack_public_path__ + "static/benefit1Img-8d6eab5fd28320841347caa38ad5b18c.webp";